'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $f_s_Product18__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.o8;
      break;
    }
    case 1: {
      return $thiz.oi;
      break;
    }
    case 2: {
      return $thiz.oj;
      break;
    }
    case 3: {
      return $thiz.ok;
      break;
    }
    case 4: {
      return $thiz.ol;
      break;
    }
    case 5: {
      return $thiz.om;
      break;
    }
    case 6: {
      return $thiz.on;
      break;
    }
    case 7: {
      return $thiz.oo;
      break;
    }
    case 8: {
      return $thiz.op;
      break;
    }
    case 9: {
      return $thiz.o9;
      break;
    }
    case 10: {
      return $thiz.oa;
      break;
    }
    case 11: {
      return $thiz.ob;
      break;
    }
    case 12: {
      return $thiz.oc;
      break;
    }
    case 13: {
      return $thiz.od;
      break;
    }
    case 14: {
      return $thiz.oe;
      break;
    }
    case 15: {
      return $thiz.of;
      break;
    }
    case 16: {
      return $thiz.og;
      break;
    }
    case 17: {
      return $thiz.oh;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 17)"));
    }
  }
}
export { $f_s_Product18__productElement__I__O as $f_s_Product18__productElement__I__O };
